import { PipelineRunDto } from '../../types/pipelineFlow';

interface PipelineStatsProps {
  pipelineRuns: PipelineRunDto[];
}

export function PipelineStats({ pipelineRuns }: PipelineStatsProps) {
  const stats = [
    {
      name: 'Recent Runs',
      value: pipelineRuns.length,
      className: 'text-gray-900',
    },
    {
      name: 'In Progress',
      value: pipelineRuns.filter((run: PipelineRunDto) => !run.isCompleted).length,
      className: 'text-blue-600',
    },
    {
      name: 'Successful',
      value: pipelineRuns.filter((run: PipelineRunDto) => run.isSuccessful).length,
      className: 'text-green-600',
    },
    {
      name: 'Failed',
      value: pipelineRuns.filter((run: PipelineRunDto) => run.isFailed).length,
      className: 'text-red-600',
    },
  ];

  return (
    <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-4">
      {stats.map((stat) => (
        <div key={stat.name} className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
          <dt className="truncate text-sm font-medium text-gray-500">{stat.name}</dt>
          <dd className={`mt-1 text-3xl font-semibold tracking-tight ${stat.className}`}>
            {stat.value}
          </dd>
        </div>
      ))}
    </div>
  );
}